import {
  IGetActiveUserDetails,
  IGetActiveUserDetailsPayload,
  IGetOrganizationDetailsAction,
  IOrganizationDetails,
  IUser,
  IUpdatePayload,
  IUpdateUserDetails,
} from "./interface";

const actionTypePrefix = "ADMIN_PANEL/";

export const adminActions = {
  ADD_ORGANIZATION_DATA: `${actionTypePrefix}GET_ORGANIZATION_DATA`,
  ADD_ORGANIZATION_DATA_SUCCESS: `${actionTypePrefix}GET_ORGANIZATION_DATA_SUCCESS`,
  ADD_ORGANIZATION_DATA_FAILURE: `${actionTypePrefix}ADD_ORGANIZATION_DATA_FAILURE`,
  FETCH_USER_LIST_REQUEST: `${actionTypePrefix}FETCH_USER_LIST_REQUEST`,
  FETCH_USER_LIST_SUCCESS: `${actionTypePrefix}FETCH_USER_LIST_SUCCESS`,
  FETCH_USER_LIST_FAILURE: `${actionTypePrefix}FETCH_USER_LIST_FAILURE`,

  GET_ACTIVE_USER_DATA: `${actionTypePrefix}GET_ACTIVE_USER_DATA`,
  UPDATE_ACTIVE_USER_DATA: `${actionTypePrefix}UPDATE_ACTIVE_USER_DATA`,
};
export const getActiveOrganizationDataById = (
  domainUrl: string
): IGetOrganizationDetailsAction => {
  return {
    type: adminActions.ADD_ORGANIZATION_DATA,
    payload: {
      domainUrl,
    },
  };
};

export const getActiveOrganizationDataSuccess = (
  organizationData: IOrganizationDetails
) => {
  return {
    type: adminActions.ADD_ORGANIZATION_DATA_SUCCESS,
    payload: {
      organizationData,
    },
  };
};
export const getActiveOrganizationDataFailure = () => {
  return {
    type: adminActions.ADD_ORGANIZATION_DATA_FAILURE,
  };
};
export const getActiveUserDetails = (
  payload: IGetActiveUserDetailsPayload
): IGetActiveUserDetails => {
  return {
    type: adminActions.GET_ACTIVE_USER_DATA,
    payload,
  };
};
export const updateUserDetails = (
  payload: IUpdatePayload
): IUpdateUserDetails => {
  return {
    type: adminActions.UPDATE_ACTIVE_USER_DATA,
    payload,
  };
};

export const getCollaborativeShareUserListRequest = () => {
  return {
    type: adminActions.FETCH_USER_LIST_REQUEST,
  }
};

export const getCollaborativeShareUserListSuccess = (users: IUser[]) => {
  return {
    type: adminActions.FETCH_USER_LIST_SUCCESS,
    payload: users,
  };
};

export const getCollaborativeShareUserListFailure = () => {
  return {
    type: adminActions.FETCH_USER_LIST_FAILURE,
  };
};
